import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as $ from 'jquery';
import { AppConfigService } from '../../config/app-config.service';


declare global {
  interface Window {
    WebChat: any;
  }
}
window.WebChat = window.WebChat || {};


@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})


export class ChatbotComponent implements OnInit {
  @ViewChild("botWindow") botWindowElement: ElementRef;

  constructor(private appConfigService: AppConfigService) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      const directLine = window.WebChat.createDirectLine({
        secret: this.appConfigService.getConfigByKey("botSecretKey"),
        webSocket: true,
      });

      const styleOptions = {
        botAvatarInitials: 'HHS',
        userAvatarInitials: 'ME',
        bubbleBackground: '#E1F0FF',
        bubbleTextColor: '#000000',
        bubbleBorderRadius: 10,
        bubbleFromUserBackground: 'rgba(21, 143, 254)',
        bubbleFromUserTextColor: 'white',
        bubbleFromUserBorderRadius: 10,
        backgroundColor: '#ffffff'
      };


      window.WebChat.renderWebChat(
        {
          directLine: directLine,
          userID: "USER_ID",
          styleOptions
        },
        this.botWindowElement.nativeElement
      );

      directLine
        .postActivity({
          from: { id: "USER_ID", name: "USER_NAME" },
          name: "requestWelcomeDialog",
          type: "event",
          value: "token"
        })
        .subscribe(
          id => console.log(`Posted activity, assigned ID ${id}`),
          error => console.log(`Error posting activity ${error}`)
        );

      directLine.activity$.subscribe((activity) => {
        //console.log('received activity ', activity);        
        setTimeout(function () {
          $(".ac-pushButton").on("click", function (e) {
            e.preventDefault();
            $(".ac-pushButton").attr("disabled", "disabled");
            $(".ac-input").prop("readonly", true);
            $(".ac-input").css("background-color", "#F2FAFF").css("border", "none");;
          });
        }, 1500);
      });

    }, 1000);
  }

}
